import { AnalyticsSource } from '@sls-react/services/analytics/AnalyticsInterfaces';
import getEnv from '@sls-react/utils/getEnv';
import fetcher from '@sls-react/api/fetcher';
import qsParse from '@sls-react/utils/qsParse';

export default function fireAnalytics(
  name: string,
  src?: AnalyticsSource,
  params?: Record<string, any>,
) {
  const urlSrc = qsParse(window.location.search).src;

  const combinedSrc = src || urlSrc;

  if (getEnv() !== 'production') {
    console.groupCollapsed(name);
    if (!combinedSrc) {
      console.warn('No Source');
    } else {
      console.log(
        'Source:',
        combinedSrc,
        !src && urlSrc ? '(using src from URL)' : '',
      );
    }
    console.log('Params:', params);
    console.groupEnd();
  }

  window.amplitude?.getInstance()?.logEvent(name, {
    ...params,
    src: combinedSrc || '',
  });

  fetcher(
    ({ uuid }) => (uuid ? '/platform-tools/analytics/v1/track/event' : false),
    {
      body: {
        event_type: name,
        properties: params || {},
      },
      method: 'post',
    },
  ).catch(() => null);
}
